import { MediaListener, MediaListenerPayload } from "./ColorFinderFootageDisplay"

export const COLORFINDER_FOOTAGE_EVENT = "colorfinder-footage-event"

export function dispatchFootageEvent(payload: MediaListenerPayload): void {
    const footageEvent = new CustomEvent<MediaListenerPayload>(COLORFINDER_FOOTAGE_EVENT, {
        detail: payload,
        bubbles: true,
        composed: true,
    })
    window.dispatchEvent(footageEvent)
}

export function subscribeToFootageEvent(handler: MediaListener): () => void {
    const internalHandler = (event: Event) => {
        if (event instanceof CustomEvent && event.type === COLORFINDER_FOOTAGE_EVENT) {
            const customEvent = event as CustomEvent<MediaListenerPayload>
            if (customEvent.detail) {
                handler(customEvent.detail)
            }
        }
    }

    window.addEventListener(COLORFINDER_FOOTAGE_EVENT, internalHandler)

    return () => {
        window.removeEventListener(COLORFINDER_FOOTAGE_EVENT, internalHandler)
    }
}
